import { DtoExt } from '@/classes/scenario/DtoExt';
import { GridComplexPricePeriod } from '@/dto/scenario/eco/GridComplexPricePeriod';
import _cheat from '@/helpers/cheatHelper';
import { dateIsAfter, DAYS_NAMES, endOf, startOf } from '@/helpers/timeHelper';

export class GridComplexPricePeriodExt extends DtoExt {

  public static fromDto(dto: GridComplexPricePeriod): GridComplexPricePeriodExt {
    const s = dto.fromDate && DtoExt.localeDateFromUtc(dto.fromDate);
    const e = dto.toDate && DtoExt.localeDateFromUtc(dto.toDate);
    return new GridComplexPricePeriodExt({
      fromDate: (!s || dateIsAfter(startOf(2018), s)) ? startOf(2018) : s,
      toDate: e,
      monday: dto.monday,
      tuesday: dto.tuesday,
      wednesday: dto.wednesday,
      thursday: dto.thursday,
      friday: dto.friday,
      saturday: dto.saturday,
      sunday: dto.sunday
    } as any);
  }

  public fromDate: Date = startOf(2018);
  public toDate: Date = endOf(2018);
  public monday: number[] = [..._cheat.typicalMockedWeek];
  public tuesday: number[] = [..._cheat.typicalMockedWeek];
  public wednesday: number[] = [..._cheat.typicalMockedWeek];
  public thursday: number[] = [..._cheat.typicalMockedWeek];
  public friday: number[] = [..._cheat.typicalMockedWeek];
  public saturday: number[] = [..._cheat.typicalMockedWeek];
  public sunday: number[] = [..._cheat.typicalMockedWeek];

  constructor(options?: Partial<GridComplexPricePeriodExt>) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
    }
  }

  public toDto(): GridComplexPricePeriod {
    return new GridComplexPricePeriod({
      fromDate: this.fromDate && DtoExt.localeDateToUtc(this.fromDate),
      toDate: this.toDate && DtoExt.localeDateToUtc(this.toDate),
      monday: this.monday,
      tuesday: this.tuesday,
      wednesday: this.wednesday,
      thursday: this.thursday,
      friday: this.friday,
      saturday: this.saturday,
      sunday: this.sunday
    });
  }

  public numberOfPriceUsed(): number {
    const combinedDaysPriceIndexes = Object.values(DAYS_NAMES)
      .flatMap((dayName: DAYS_NAMES) => this[dayName]);
    return Math.max(...combinedDaysPriceIndexes) + 1;
  }
}
